import { Component } from '@angular/core'

@Component({
  selector: 'cover-new-payment-method',
  templateUrl: './new-payment-method.component.html',
  styleUrls: ['./new-payment-method.component.scss'],
})
export class NewPaymentMethodComponent {
  paymentMethods = []
}
